import React, { PureComponent } from "react";
import WelcomeLayout from "../../layouts/welcome";

class TeamReportsSection7Step1 extends PureComponent {
  get right_content() {
    return <span>What is the end results?</span>;
  }

  render() {
    return (
      <WelcomeLayout
        title="Financial Reports"
        right_content={this.right_content}
      />
    );
  }
}

export default TeamReportsSection7Step1;



// WEBPACK FOOTER //
// ./src/components/team-reports/steps/section-7/step-1.js